import { render, staticRenderFns } from "./loadingBox.vue?vue&type=template&id=274f110f&scoped=true&"
import script from "./loadingBox.vue?vue&type=script&lang=js&"
export * from "./loadingBox.vue?vue&type=script&lang=js&"
import style0 from "./loadingBox.vue?vue&type=style&index=0&id=274f110f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f110f",
  null
  
)

export default component.exports